<template>
	<section class="about mb-1d2">
		<div
			v-if="item?.logo?.url"
			class="about__image"
		>
			<img
				:src="img"
				:srcset="`${img}, ${img2x} 2x`"
				:alt="getAltTitleForLogo"
				class="img img--cover"
			>
		</div>
		<div class="about__data">
			<div class="about__main">
				<div class="about__headline">
					<h1 class="about__title headline-1">
						{{ item?.name }}
<!--						<i-->
<!--							v-if="type === 'studio'"-->
<!--							class="icon-star-check-2 about__icon"-->
<!--						></i>-->
					</h1>

					<div v-if="item?.views" class="about__view">
						<i class="icon-eye about__icon"></i>
						<span class="headline-3">{{ item?.views }}</span>
					</div>
				</div>

				<div v-if="item?.total_supply" class="about__row">
					<div class="about__count">
						<i class="icon-archive c-pink about__icon"></i>
						<span class="body-1 about__count-text">{{ $t('totalSupply') }}:</span>

						<span class="headline-4">{{ item.total_supply }}</span>
					</div>
				</div>

				<div v-if="item?.twitter_followers || item?.discord_members" class="about__row">
					<div v-if="item?.twitter_followers" class="about__count">
						<i class="about__icon icon-twitter"></i>
						{{ $helpers.formatFollowers(item.twitter_followers) }}
						<i class="about__count-text icon-group"></i>
					</div>
					<div v-if="item?.discord_members" class="about__count">
						<i class="icon-discord about__icon"></i>
						{{ $helpers.formatFollowers(item.discord_members) }}
						<i class="about__count-text icon-group"></i>
					</div>
				</div>

				<div v-if="item?.start_date?.length" class="about__row">
					<div class="about__row-2">
						<a v-if="item?.add_google_calendar" :href="item.add_google_calendar" class="block-card__icon icon-calendar-add about__icon c-pink" target="_blank"></a>
						<span v-else class="icon-calendar-add about__icon c-link"></span>
						<span class="headline-4">{{ formatedDates }}</span>
					</div>
				</div>

				<div v-if="item?.source_url?.length" class="about__count ai-center pointer">
					<a target="_blank" :href="item?.source_url[0].url" class="headline-2">{{ $t('source') }}</a>
				</div>
			</div>
			<div class="about__icons">
				<div class="about__row-2">
					<a
                        v-if="item?.website_url"
						:href="item.website_url"
						class="icon-web about__icon about__link"
						target="_blank"
					></a>
					<a
                        v-if="item?.social_networks"
						v-for="social in item.social_networks"
						:key="social.name"
						:href="social.url"
						target="_blank"
						:class="`icon-${social.name.toLowerCase()}`"
						class="about__icon about__link"
					></a>
<!--					<a-->
<!--						href="#"-->
<!--						class="icon-menu about__icon about__link"-->
<!--					></a>-->
					<i
						class="icon-share about__icon about__link"
						data-target="share"
						@click="onCopyShareLink"
					></i>
				</div>
				<div
					v-if="typeof item?.confidence !== 'undefined' || typeof item?.votes !== 'undefined'"
					class="about__row-2"
				>
					<div v-if="typeof item?.confidence !== 'undefined'" class="about__stat">
						<span class="about__stat-title body-2">{{ $t('confidence') }}</span>
						<span class="about__stat-value headline-4">{{ item?.confidence }}% </span>
					</div>
					<div v-if="typeof item?.votes !== 'undefined'" class="about__stat">
						<span class="about__stat-title body-2">{{ $t('votes') }}</span>
						<span class="about__stat-value headline-4">{{ item?.votes }}</span>
					</div>

				</div>

				<div v-if="item?.voting_count" class="about__row-2">
					<i class="icon-arrow-up c-green pointer about__icon"></i>
					<span class="headline-3">{{ item.voting_count }}</span>
					<i class="icon-arrow-down c-red pointer about__icon"></i>
				</div>

				<div v-if="type === 'event'" class="about__row-2">
					<div class="about__action">
						<i class="icon-like about__icon" style="font-size: 23px"></i>
						<span class="headline-2">{{ $t('true') }}</span>
					</div>
					<div class="about__action">
						<i class="icon-dislike about__icon" style="font-size: 23px"></i>
						<span class="headline-2">{{ $t('fud') }}</span>
					</div>
				</div>
			</div>
		</div>

	</section>
</template>

<script>
const dayjs = useDayjs();

export default {
	name: 'HeaderInfo',
	props: {
		type: {
			type: String,
			required: true
		},
		item: {
			type: Object,
			required: true
		}
	},
	setup() {
		const { locale } = useI18n();
		const { $helpers } = useNuxtApp()

		return {
			locale,
			dateLocaleMapping: $helpers.dateLocaleMapping
		}
	},
	computed: {
		formatter() {
			return this.dateLocaleMapping[this.locale] ?? this.dateLocaleMapping['en']
		},
		formatedDates() {
			let formatedDates = '';

			if (this.item?.start_date) {
				formatedDates += dayjs(this.item?.start_date).format(this.$config.public.dateFormatPretty);

				if (this.item?.start_time) {
					formatedDates += ' ' + this.item?.start_time;
				}

				if (this.item?.end_date) {
					formatedDates += ' - ' + dayjs(this.item?.end_date).format(this.$config.public.dateFormatPretty);

					if (this.item?.end_time) {
						formatedDates += ' ' + this.item?.end_time;
					}
				}
			}

			return formatedDates;
		},
		getAltTitleForLogo() {
			return this.type === 'studio' ? `Logo of ${this.item?.name}` : `${this.item?.name}`
		},
		img() {
			return `${this.$config.public.HOST_BACKEND}${this.item?.logo?.url + '/s.webp' || this.defaultImg}`;
		},
		img2x() {
			return `${this.$config.public.HOST_BACKEND}${this.item?.logo?.url + '/s2x.webp' || this.defaultImg}`;
		},
	},
	methods: {
		onCopyShareLink() {
			navigator.clipboard.writeText(window.location.href).then(() => {
				this.$toast.info('URL to this page is copied to clipboard!', {
					timeout: 2000
				})

			}, function(err) {
				console.error('Async: Could not copy URL: ', err);
			});
		}
	}
}
</script>
